import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=33842207&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=33842207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33842207",
  null
  
)

export default component.exports